import { TextField } from '@efexteam/components';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { useTranslation } from 'react-i18next';
import SearchBarStyles from './SearchBar.style';
import { ISearchBar } from './types/SearchBar.type';

const SearchBar = ({ setSearch, search }: ISearchBar) => {
  const { t } = useTranslation();

  return (
    <TextField
      fullWidth
      size="small"
      className={SearchBarStyles.searchBar}
      placeholder={t('teamRoleSearch') as string}
      onChange={(e) => {
        setSearch(e.target.value);
      }}
      value={search}
      InputProps={{
        endAdornment: (
          <SearchOutlinedIcon className={SearchBarStyles.searchBarIcon} />
        ),
      }}
    />
  );
};

export default SearchBar;
